<template>
  <div>
    <el-upload
      :file-list="picture"
      :action="uploadUrl"
      :on-success="handlePictureCardPreview"
      :on-remove="handleRemove"
      :headers="headers"
      name="files"
      :limit="1"
      :multiple="false"
      accept=".wav,.mp3,.mp4,.avi,.wmv"
    >
      <div class="uploadClass">
        <el-button type="primary" plain>商品视频上传</el-button>
        <div class="tips">视频频支持:.mp4,.avi,.wmv格式</div>
      </div>
    </el-upload>
    <el-button
      v-if="picture.length && picture[0].url"
      class="btn"
      type="primary"
      @click="handlePictureCardPreview1"
      >视频预览</el-button
    >
    <el-dialog :visible.sync="dialogVisible" width="40%" title="预览">
      <video
        :src="picture.length && picture[0].url"
        muted
        autoplay
        :controls="true"
        class="video"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      picture: [],
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      uploadUrl: process.env.VUE_APP_API + "/api/common/fileInfo/newUpload",
    };
  },
  mounted() {
    this.picture = this.value.url ? [this.value] : [];
  },
  methods: {
    handlePictureCardPreview1() {
      this.dialogVisible = true;
    },
    handlePictureCardPreview(response, file) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        this.picture = response.data.map((item) => ({
          url: item.fileUrl, // 直接提取 url 字段
          name: file.name,
        }));
        this.$emit("success", this.picture[0]);
      }
    },
    handleRemove() {
      // 删除图片
      this.picture = [];
    },
  },
};
</script>

<style scoped lang="scss">
.uploadClass {
  display: flex;
  flex-flow: column;
  gap: 15px;
  align-items: center;

  .tips {
    color: rgba(172, 178, 195, 1);
    font-size: 12px;
  }
}
::deep.el-upload-list__item-name {
  color: #333;
}
.btn {
  margin-top: 15px;
  margin-left: 35px;
}
.video {
  width: 100%;
}
</style>
